export const FLAG_WORDS = [
  'guaranteed',
  'risk-free',
  'will definitely',
  'certain returns',
  "can't lose",
  'no risk',
  'always profitable',
  'never lose',
];

export const DISCLAIMER =
  'This content is for informational purposes only and does not constitute financial advice. Past performance is not indicative of future results.';

export function complianceCheck(content) {
  const text = content || '';
  const lowered = text.toLowerCase();
  const flagged = FLAG_WORDS.filter((word) => lowered.includes(word));

  if (flagged.length > 0) {
    const separator = text ? '\n\n' : '';
    return {
      clean_content: `${text}${separator}${DISCLAIMER}`,
      disclaimer_added: true,
      flagged_words: flagged,
    };
  }

  return {
    clean_content: text,
    disclaimer_added: false,
    flagged_words: [],
  };
}
